export * from './httpService/HttpService';
export * from './makeServices/makeServices';
export * from './token/index';

export const constants = {
	landingPageUrl: 'app.acciojob.com',
};
